import { useDispatchToStore, useSelectorToStore } from '@hooks/reduxHooks';
import { useRouter } from 'next/router';
import { seeAllTypes } from '@constants/index';
import TopBlock from '@cont/SeeAll/TopBlock';
import ClassFeedBlock from '@cont/SeeAll/ClassFeedBlock';
import { fetchAllSpecialClasses } from '@actions/specialClasses';
import { emptyObject } from '@constants/empty';

const AllSpecialClasses = ({ subjectUid }) => {
  const router = useRouter();
  const { goalUID } = router.query;
  const classes = useSelectorToStore(
    ({ paginator }) => paginator.allSpecialClasses
  );
  const dispatch = useDispatchToStore();
  const goalInfo = useSelectorToStore(
    ({ topologies }) => topologies.topologyDetails[goalUID] || emptyObject
  );

  const loadMore = () => {
    return dispatch(fetchAllSpecialClasses(subjectUid, true));
  };

  return (
    <>
      <TopBlock
        label="Free classes"
        goal={goalInfo}
        seeAllType={seeAllTypes.SPECIAL_CLASS}
        isDropdown={false}
      />

      <ClassFeedBlock
        classFeedBlock={classes}
        goalSlug={goalInfo.slug}
        goalUID={goalUID}
        goalkey={subjectUid}
        // blockId={blockId}
        // defaultBlockURL={defaultBlockURL}
        seeAllType={seeAllTypes.SPECIAL_CLASS}
        // blockType={
        //   type !== 'my_classes' ? type : `${type}-${selectedMenu?.value}`
        // }
        customLoadMore={loadMore}
        dropdownOption={false}
        label="Free classes"
      />
    </>
  );
};

export default AllSpecialClasses;
